import styled from 'styled-components'

import { OrderItemPriceV2 } from '~/components/order-item-price'

export const OrderItemPriceV3 = styled(OrderItemPriceV2)`
  padding-top: 10px;
  font-size: 18px;
`
